module.exports = __webpack_public_path__ + "static/media/triangle_1.2ac85ec9.png";